import { render } from "./menuitem.vue?vue&type=template&id=3c254b1a&scoped=true"
import script from "./menuitem.vue?vue&type=script&lang=js"
export * from "./menuitem.vue?vue&type=script&lang=js"

import "./menuitem.vue?vue&type=style&index=0&id=3c254b1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c254b1a"]])

export default __exports__